import React, { FC } from 'react';
import { Button, Col, Row, Typography } from 'components';
import { DeleteIcon, EditIcon } from 'components/common/icons';
import styles from './styles.module.scss';
import { CountryClientTypeAddEditModal } from 'feature/countryTabs/pricing/clientTypePricingRules/edit';
import { useClientTypePricingRuleCard } from 'feature/countryTabs/pricing/clientTypePricingRules/clinetTypePricingRuleCard/useClientTypePricingRuleCard';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';

const { Text } = Typography;

interface IShippingAddress {
  data: Record<string, any>;
  onDeleteModalOpen: (id: string) => void;
}

export const ClientTypePricingRuleCard: FC<IShippingAddress> = React.memo((props) => {
  const { data, onDeleteModalOpen } = props;
  const { markup, minMargin, maxMargin, id, clientType } = data;
  const { name, id: clientTypeId } = clientType;
  const { addModalState, onAddModalStateChange } = useClientTypePricingRuleCard();
  return (
    <>
      <>
        <Row gutter={[0, 10]} className={styles.country_client_pricing_rule_card}>
          <Col span={24}>
            <Row justify={'space-between'} gutter={[16, 0]} wrap={false}>
              <Col>
                <Text style={{ color: '#222530', fontWeight: 500, fontSize: 16 }}>{name}</Text>
              </Col>
              <Col>
                <Row wrap={false}>
                  <Col>
                    <HasAccess role={PERMISSIONS.countries.client_pricing_rules.delete}>
                      <Button
                        size={'small'}
                        type={'text'}
                        onClick={() => onDeleteModalOpen(id)}
                        icon={<DeleteIcon />}
                      />
                    </HasAccess>
                  </Col>
                  <Col>
                    <HasAccess role={PERMISSIONS.countries.client_pricing_rules.write}>
                      <Button size={'small'} type={'text'} onClick={onAddModalStateChange} icon={<EditIcon />} />
                    </HasAccess>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 4]}>
              <Col span={24}>
                <Row justify={'space-between'} align={'middle'}>
                  <Col>
                    <Text type={'secondary'}>Margin</Text>
                  </Col>
                  <Col>
                    <Text type={'secondary'}>{markup !== null && markup !== undefined ? `${markup}%` : 'Not Set'}</Text>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row justify={'space-between'} align={'middle'}>
                  <Col>
                    <Text type={'secondary'}>Margin Range</Text>
                  </Col>
                  <Col>
                    <Text type={'secondary'}>
                      {minMargin !== null && minMargin !== undefined && maxMargin !== null && maxMargin !== undefined
                        ? `${minMargin}-${maxMargin}%`
                        : minMargin !== null && minMargin !== undefined
                          ? `${minMargin} Min`
                          : maxMargin !== null && maxMargin !== undefined
                            ? `${maxMargin} Max`
                            : 'Not Set'}
                    </Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <CountryClientTypeAddEditModal
          onModalStateChange={onAddModalStateChange}
          modalState={addModalState}
          dataToEdit={{ ...data, clientTypeId }}
        />
      </>
    </>
  );
});
